import { useEffect, useRef } from 'react';

/** Салют из конфетти на 3,5 секунды. При «уменьшить движение» — не показываем. */
export function Confetti({ onDone }: { onDone: () => void }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useEffect(() => {
    if (window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) {
      onDone();
      return;
    }
    const cv = ref.current!;
    const g = cv.getContext('2d');
    if (!g) return onDone();
    const dpr = window.devicePixelRatio || 1;
    const W = window.innerWidth;
    const H = window.innerHeight;
    cv.width = W * dpr;
    cv.height = H * dpr;
    g.scale(dpr, dpr);
    const colors = ['#d9622b', '#6b62d6', '#c99400', '#1f9e8f', '#f2b36b', '#e0835a', '#8e91f2'];
    const parts = Array.from({ length: 160 }, (_, i) => {
      const fromLeft = i % 2 === 0;
      return {
        x: fromLeft ? 0 : W,
        y: H * 0.75,
        vx: (fromLeft ? 1 : -1) * (4 + Math.random() * 7),
        vy: -(9 + Math.random() * 9),
        r: 4 + Math.random() * 5,
        a: Math.random() * Math.PI,
        va: (Math.random() - 0.5) * 0.3,
        c: colors[i % colors.length]!,
      };
    });
    const t0 = performance.now();
    let raf = 0;
    const frame = (t: number) => {
      const k = (t - t0) / 3500;
      g.clearRect(0, 0, W, H);
      for (const p of parts) {
        p.vy += 0.28;
        p.vx *= 0.99;
        p.x += p.vx;
        p.y += p.vy;
        p.a += p.va;
        g.save();
        g.globalAlpha = Math.max(0, 1 - k);
        g.translate(p.x, p.y);
        g.rotate(p.a);
        g.fillStyle = p.c;
        g.fillRect(-p.r, -p.r / 2, p.r * 2, p.r);
        g.restore();
      }
      if (k < 1) raf = requestAnimationFrame(frame);
      else onDone();
    };
    raf = requestAnimationFrame(frame);
    return () => cancelAnimationFrame(raf);
  }, []);
  return <canvas ref={ref} className="confetti" aria-hidden="true" />;
}
